import Rest from '@/services/Rest';

/**
 * @typedef {ResetPasswordService}
 */
export default class ResetPasswordService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/v2/adm/auth/reset-password'
}
